<div nz-row>
    <div nz-col [nzSm]="{span: 24}" [nzMd]="{span: 14, offset: 5}" [nzLg]="{span: 10, offset: 7}">
        <nz-card nzType="inner" nzBorderless>
            <form nz-form [formGroup]="form" class="login-form" (ngSubmit)="onForgotPassword()">
                <div class="form-section-helper-text">
                    <span>Provide your email address below and we will send you
                        a link to reset your password.</span>
                </div>
                <nz-form-item *ngIf="unknownErrorMessages.length > 0">
                    <nz-alert nzType="error" *ngFor="let message of unknownErrorMessages" [nzMessage]="message"
                              nzShowIcon></nz-alert>
                </nz-form-item>
                <nz-form-item>
                    <mat-form-field class="email-input" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Email</mat-label>
                        <input type="email" matInput formControlName="email" autocomplete="email" required/>
                        @if (form.get('email').invalid) {
                            <mat-error>{{ getErrorMessage('email') }}</mat-error>
                        }
                    </mat-form-field>
                </nz-form-item>
                <button class="hill-button-secondary send-password-reset-link-button" type="submit" [disabled]="isAuthenticating">
                    <span class="loading-icon" *ngIf="isAuthenticating" nz-icon nzType="loading" nzTheme="outline"></span> Send password reset link
                </button>
            </form>
            <nz-divider nzDashed></nz-divider>
            <button id="createBtn"
                    class="hill-button-secondary-outline back-to-login-button"
                    (click)="onLogin()">
                Return to log in
            </button>
        </nz-card>
    </div>
</div>
